import FilterPriceDisclaimer from './FilterPriceDisclaimer';
export default FilterPriceDisclaimer;